module.exports = __webpack_public_path__ + "static/media/初级开发者.7bc984e1.png";